__turbopack_context__.v({
  "SpecializationCard__InnerImage": "KeySpecializationCardLp-module-scss-module__U709RG__SpecializationCard__InnerImage",
  "SpecializationCard__InnerShowMoreIcon": "KeySpecializationCardLp-module-scss-module__U709RG__SpecializationCard__InnerShowMoreIcon",
  "SpecializationCard__InnerTitle": "KeySpecializationCardLp-module-scss-module__U709RG__SpecializationCard__InnerTitle",
  "SpecializationCard__background": "KeySpecializationCardLp-module-scss-module__U709RG__SpecializationCard__background",
  "SpecializationCard__plusImage": "KeySpecializationCardLp-module-scss-module__U709RG__SpecializationCard__plusImage",
  "root": "KeySpecializationCardLp-module-scss-module__U709RG__root",
  "specializationsCarousel": "KeySpecializationCardLp-module-scss-module__U709RG__specializationsCarousel",
  "sponsored-image": "KeySpecializationCardLp-module-scss-module__U709RG__sponsored-image",
  "sponsored-image-wrapper": "KeySpecializationCardLp-module-scss-module__U709RG__sponsored-image-wrapper",
  "swiper-slide": "KeySpecializationCardLp-module-scss-module__U709RG__swiper-slide",
});
